import { render, staticRenderFns } from "./AccessWalletKeepkey.vue?vue&type=template&id=25712a7a&scoped=true"
import script from "./AccessWalletKeepkey.vue?vue&type=script&lang=js"
export * from "./AccessWalletKeepkey.vue?vue&type=script&lang=js"
import style0 from "./AccessWalletKeepkey.vue?vue&type=style&index=0&id=25712a7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25712a7a",
  null
  
)

export default component.exports